import { MOBILE_ANCHOR_SCROLL_DURATION_SEC } from "@/scrollPresets";

/** While true, mobile story scroll gates must not clamp Lenis (nav anchor jumps). */
let active = false;
let teardown = null;

export const MOBILE_ANCHOR_NAV_EVENT = "sparkl:mobile-anchor-nav";

export function isMobileAnchorNavigationActive() {
  return active;
}

/**
 * Suspend mobile scroll gates for an in-page anchor jump.
 * @param {import('lenis').default | null | undefined} lenis
 * @param {number} durationSec expected Lenis scrollTo duration
 * @param {string} [hash] target hash e.g. "#live"
 */
export function beginMobileAnchorNavigation(
  lenis,
  durationSec = MOBILE_ANCHOR_SCROLL_DURATION_SEC,
  hash,
) {
  active = true;
  if (teardown) teardown();

  let settledTimer = 0;
  let hardTimer = 0;
  let onScroll = null;

  const finish = () => {
    active = false;
    if (onScroll && lenis) lenis.off("scroll", onScroll);
    clearTimeout(settledTimer);
    clearTimeout(hardTimer);
    teardown = null;
  };

  const scheduleFinish = () => {
    clearTimeout(settledTimer);
    settledTimer = setTimeout(finish, 120);
  };

  if (lenis) {
    onScroll = () => {
      const vel = Math.abs(lenis.velocity ?? 0);
      if (vel < 0.12) scheduleFinish();
    };
    lenis.on("scroll", onScroll);
  }

  hardTimer = setTimeout(finish, Math.max(900, durationSec * 1000 + 450));
  teardown = finish;

  if (hash) {
    window.dispatchEvent(
      new CustomEvent(MOBILE_ANCHOR_NAV_EVENT, { detail: { hash } }),
    );
  }
}
